<template>
  <div class="wrapper ym-hide-content">
    <div class="logoDocHead">
      <svg width="643" height="117" viewBox="0 0 643 117" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M85.067 30.323c-7.803.39-14.436 4.288-18.728 10.134C62.827 35 57.365 31.103 50.73 29.934v8.574c6.633 1.949 11.316 7.795 11.316 14.81h8.584c.39-6.625 5.072-12.082 11.315-14.03v48.329h8.194V30.323h-5.073z" fill="#3FAE2A"/><path d="M49.938 29.551h-7.412c-11.316 1.949-19.9 11.693-19.9 23.385 0 11.693 8.584 21.437 19.509 23.385v10.913h8.584V76.321c8.584-1.559 15.997-8.184 18.338-16.37h-8.974c-1.95 3.898-5.462 6.627-9.364 7.796V29.94c-.39-.39-.78-.39-.78-.39zm-7.803 38.196c-6.633-1.949-11.315-7.795-11.315-14.81 0-7.016 4.682-12.863 11.315-14.811v29.62z" fill="#00563F"/><path d="M8.194 58.463C8.194 35.078 23.8 15.2 45.26 8.964V0C19.509 6.626 0 30.011 0 58.463s19.509 51.837 45.65 58.463v-8.575C24.192 101.725 8.195 81.848 8.195 58.463zM120.173 58.464c0-28.062-19.509-51.837-45.65-58.463v8.575c21.46 6.236 37.066 26.113 37.066 49.498 0 23.385-15.607 43.263-37.067 49.499v8.574c26.533-6.236 45.651-29.62 45.651-57.683z" fill="#00563F"/><path d="M163.846 83.75c-7.804 0-14.437-2.338-19.509-7.015-5.073-4.677-7.804-10.913-7.804-18.319 0-7.405 2.731-13.641 7.804-18.318 5.072-4.677 11.705-7.016 19.509-7.016h1.17v-5.066l-7.413-1.17V21h24.191v5.846l-7.804 1.17v5.066h1.171c7.803 0 14.436 2.339 19.509 7.016 5.072 4.677 7.803 10.913 7.803 18.318 0 7.406-2.731 13.642-7.803 18.319-5.073 4.677-11.706 7.015-19.509 7.015h-1.171v4.677l7.414 1.17v5.846h-24.191v-5.846l7.413-1.17V83.75h-.78zm0-43.652c-5.853 0-10.145 1.559-13.657 5.067-3.121 3.118-4.682 7.795-4.682 13.251 0 5.457 1.561 10.134 4.682 13.252 3.122 3.118 7.804 5.067 13.657 5.067h1.17V40.098h-1.17zm10.144 0v36.637h1.171c5.853 0 10.145-1.56 13.266-5.067 3.121-3.118 4.682-7.795 4.682-13.252 0-5.456-1.561-10.133-4.682-13.251-3.121-3.118-7.804-5.067-13.266-5.067h-1.171zM234.087 24.513v5.846l-7.413 1.17v38.585h.39l32.385-34.688v-3.508l-7.414-1.169v-6.236h23.801v5.846l-7.413 1.17v53.006l7.413 1.17v5.846h-24.191v-5.847l7.414-1.169V47.12h-.391l-32.384 34.688v3.118l7.413 1.17v5.845h-24.191v-5.846l7.413-1.17V31.919l-7.413-1.169v-6.236H234.087zM282.458 30.36v-5.847h24.191v5.846l-7.414 1.17v23.385h32.775V31.529l-7.413-1.17v-5.846H348.398v5.846l-7.414 1.17v53.006l7.414 1.17v5.846h-24.191v-5.847l7.413-1.169V61.93h-32.775v22.605l7.413 1.17v5.846h-24.191v-5.847l7.414-1.169V31.92l-7.023-1.56z" fill="#3FAE2A"/><path d="M420.974 38.154l-21.85 53.786h-6.243l-21.85-53.785h-.39l.78 27.282v19.488l7.414 1.17v5.845h-24.191v-5.846l7.413-1.17V31.919l-7.413-1.169v-6.236H373.762l21.46 54.566h.39l21.46-54.566h19.119v5.846l-7.414 1.17v53.006l7.414 1.17v5.846H412v-5.847l7.413-1.169V65.048l1.561-26.894zM502.917 58.81c0 9.743-2.731 17.928-8.584 24.164-5.462 6.626-12.876 9.744-21.85 9.744-8.584 0-15.607-3.118-21.07-9.744-5.462-6.626-8.193-14.421-8.193-24.165v-1.17c0-9.743 2.731-17.928 8.193-24.164 5.463-6.236 12.486-9.744 21.07-9.744 8.974 0 16.388 3.118 21.85 9.744 5.463 6.626 8.584 14.421 8.584 24.165v1.17zm-8.974-1.17c0-7.795-1.951-14.031-5.463-19.098-3.511-5.067-8.974-7.405-15.607-7.405-6.243 0-11.315 2.338-14.826 7.405-3.512 5.067-5.463 11.303-5.463 19.098v1.17c0 7.794 1.951 14.42 5.463 19.097 3.511 5.067 8.583 7.405 14.826 7.405 6.633 0 12.096-2.338 15.607-7.405 3.512-5.067 5.463-11.303 5.463-19.098v-1.17zM531.792 31.919l-1.171 24.554c-.78 12.472-2.341 21.826-5.462 27.283-3.122 5.456-8.194 8.184-15.217 8.184h-2.341v-7.015h1.95c4.292 0 7.024-1.949 8.975-6.236 1.56-4.287 2.731-11.693 3.121-22.216l1.171-24.554-7.024-1.17v-6.236h56.186v5.846l-7.804 1.56v53.006l7.414 1.17v5.845h-24.191v-5.846l7.413-1.17V31.919h-23.02zM602.403 31.919l-1.171 24.554c-.78 12.472-2.341 21.826-5.462 27.283-3.121 5.456-8.194 8.184-15.217 8.184h-2.341v-7.015h1.951c4.292 0 7.023-1.949 8.974-6.236 1.561-4.287 2.731-11.693 3.121-22.216l1.171-24.554-7.023-1.17v-6.236h55.795v5.846l-7.413 1.17v53.006l7.413 1.17v5.846H618.01v-5.847l7.413-1.169V31.92h-23.02z" fill="#00563F"/></svg>
      <p>
        Общество с ограниченной ответственностью Микрокредитная компания "Финмолл" (ООО МКК "Финмолл"). РФ, 630112,
        г.Новосибирск, ул. Фрунзе, д.242, пом. 406. ОГРН 1117746509638, ИНН 7705954143, КПП 785250001, р\с
        40701810738000002048, к\с 30101810400000000225, БИК 044525225, ПАО Сбербанк, №9038/01675, 119034, г. Москва, б-р
        Зубовский, 13, 1. www.finmoll.ru Тел.: 8 800 600 99 90
      </p>
    </div>
    <div class="header">
      <h3>СОГЛАСИЕ СУБЪЕКТА КРЕДИТНОЙ ИСТОРИИ<br/> НА ПОЛУЧЕНИЕ ИНФОРМАЦИИ ИЗ БЮРО КРЕДИТНЫХ ИСТОРИЙ</h3>
      <div>
        <p>г. Москва</p>
        <p>«{{ loandDay }}» {{ loanMonth }} {{ loanYear }} года</p>
      </div>
    </div>
    <section class="section">
      <p>
        Я, персональные данные которого указаны в заявке, заполненной на сайте, расположенном в
        информационно-коммуникационной сети «Интернет» по адресу:
        {{ loanUrl }}, либо непосредственно в тексте данного согласия
      </p>
    </section>

    <section class="section">
      <p><strong>Информация о Субъекте кредитной истории:</strong></p>
      <p>Ф.И.О.<b>{{ '  ' + dg.LAST_NAME + ' ' + dg.FIRST_NAME + ' ' + dg.SECOND_NAME }}</b><br>
        Дата рождения: <b>{{ '  ' + dg.BIRTHDAY }}</b><br>
        Место рождения: <b>{{ '  ' + dg.BIRTHPLACE }}</b><br>
        Паспортные данные (серия, номер, дата выдачи, наименование органа, выдавшего паспорт, код подразделения): <br>
        <b>{{ '  ' + dg.PASSPORT_SERIES + ' ' + dg.PASSPORT_NUMBER + ' ' + dg.PASSPORT_DATE + ' ' + dg.PASSPORT_DEP + ' ' + dg.PASSPORT_DEP_CODE }}</b>
        <br>
        Адрес регистрации: <b>{{ ' ' + dg.REGISTRATION_ADDRESS }}</b><br>
        Фактический адрес проживания: <b>{{ '  ' + dg.RESIDENTIAL_ADDRESS }}</b><br>
        ИНН: <b>{{ '  ' + dg.INN }}</b><br>
        СНИЛС: <b>{{ '  ' + dg.extended.SNILS }}</b><br>
      </p>
    </section>

    <section class="section">
      <div>(Далее именуемый – Клиент) выступая в качестве субъекта персональных данных и субъекта кредитной истории, в
        соответствии с Федеральным законом № 218-ФЗ от 31.12.2004г. «О Кредитных историях», принимаю решение о
        предоставлении моих персональных данных и даю согласие на их обработку свободно, своей волей и в своем интересе
        Обществу с ограниченной ответственностью Микрокредитная компания «ФИНМОЛЛ» (ОГРН 1117746509638, юр. адрес:
        630112, г. Новосибирск, ул. Фрунзе, д.242, пом. 406, а также а также обособленному подразделению ООО МКК
        «ФИНМОЛЛ», расположенному по адресу: 121059 г. Москва, Бережковская наб, д 16А стр 2), далее именуемого
        «Общество» в следующих целях:
        <ul>
          <li>• рассмотрение заявки на получение займа, проверка благонадежности;</li>
          <li>• заключение и исполнение договора займа</li>
        </ul>
      </div>
      <p>В соответствии с п.1 ст.6 Федерального закона от 30.12.2004г. № 218-ФЗ «О кредитных историях» я, даю согласие
        на запрос Обществом, как пользователем кредитной истории, кредитных отчетов, включая телефонные номера указанных
        в них, от бюро кредитных историй с целью оценки исполнения принятых на Клиента обязательств перед финансовыми
        организациями по договорам займа, иным договорам, в целях принятия решения о заключении договора
        потребительского займа по поданной им заявке/заявлении на получение потребительского займа, заключения и
        исполнения договора потребительского займа, а также для целей принятия решения об изменении лимита
        кредитования.</p>
      <p>Согласие в части отказа от запроса кредитного отчёта / истории может быть отозвано Клиентом в любой момент
        путем информирования Общества посредством направления соответствующего уведомления о его отзыве Обществу по
        адресу: 630112, Новосибирская область, г. Новосибирск, ул. Фрунзе дом 242, помещение 406, либо по адресу
        электронной почты Общества _________________. </p>
      <p>Подписано простой электронной подписью в соответствии с Соглашением об использовании простой электронной
        подписи.<br/>
        «(код){{ dg.confCode }}» (ФИО){{ ' ' + dg.LAST_NAME + ' ' + dg.FIRST_NAME + ' ' + dg.SECOND_NAME }}
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: "docKI",
  data() {
    return {
      dg: {
        LAST_NAME: '',
        FIRST_NAME: '',
        SECOND_NAME: '',
        BIRTHDAY: '',
        BIRTHPLACE: '',
        PASSPORT_SERIES: '',
        PASSPORT_NUMBER: '',
        PASSPORT_DATE: '',
        PASSPORT_DEP: '',
        PASSPORT_DEP_CODE: '',
        REGISTRATION_ADDRESS: '',
        RESIDENTIAL_ADDRESS: '',
        INN: '',
        extended: {
          SNILS: '',
          pdlGetSelectedDeal: {
            PercentageRate: ''
          }
        },
        url: '',
        confCode: '',
        dtCreate: null,
      },
    }
  },
  methods: {
    loadIU() {
      try {
        this.$axios({
          method: 'post',
          url: process.env.VUE_APP_URL_LOAN,
          data: {
            action: 'getIU',
            token: this.$route.params.token,
            session_id: this.$route.params.session_id
          }
        }).then(res => {
          try {
            console.log(res)
            if (res.data.result.extended !== undefined) {
              res.data.result.extended = JSON.parse(res.data.result.extended);
              // if ( res.data.result.extended.pdlGetSelectedDeal !== undefined){
              //   res.data.result.extended.pdlGetSelectedDeal = JSON.parse(res.data.result.extended.pdlGetSelectedDeal);
              // }
            }
          } catch (e) {
            console.log(e)
          }
          this.dg = Object.assign(this.dg, res.data.result);
        }).catch(res => {
          console.log(res);
          alert('Ошибка формирования иу sid=' + this.$route.params.session_id)
        });
      } catch (e) {
        alert('Ошибка формирования иу sid=' + this.$route.params.session_id)
      }
    }
  },
  mounted() {
    this.loadIU();
  },
  computed: {
    loanUrl() {
      return document.location.origin + '' + this.dg.url;
    },
    loandDay() {
      let out = '';
      if (this.dtCreate === null) return out;

      try {
        const dt = new Date(this.dg.dtCreate);
        out = dt.getDate() < 10 ? '0' + dt.getDate() : dt.getDate();
      } catch ($err) {
        console.log('data err')
      }
      return out;
    },
    loanYear() {
      let out = '';
      if (this.dtCreate === null) return out;
      try {
        const dt = new Date(this.dg.dtCreate);
        out = dt.getFullYear();
      } catch ($err) {
        console.log('data err')
      }
      return out;
    },
    loanMonth() {
      let out = '';
      if (this.dtCreate === null) return out;
      try {
        const dt = new Date(this.dg.dtCreate);
        switch (dt.getMonth()) {
          case 0:
            out = 'Января';
            break;
          case 1:
            out = 'Февраля';
            break;
          case 2:
            out = 'Марта';
            break;
          case 3:
            out = 'Апреля';
            break;
          case 4:
            out = 'Мая';
            break;
          case 5:
            out = 'Июня';
            break;
          case 6:
            out = 'Июля';
            break;
          case 7:
            out = 'Августа';
            break;
          case 8:
            out = 'Сентября';
            break;
          case 9:
            out = 'Октября';
            break;
          case 10:
            out = 'Ноября';
            break;
          case 11:
            out = 'Декабря';
            break;
        }
      } catch ($err) {
        console.log('data err')
      }
      return out;
    }
  },
  created() {
    window.addEventListener('focus', this.loadIU)
  }
}
</script>

<style scoped>
.wrapper {
  margin: auto;
  padding: 2.94vw;
  font-size: 3.53vw;
  line-height: 1.5;
}

.section {
  margin-bottom: 8.82vw;
  padding: 0
}

.section p {
  margin-bottom: 1.47vw;
}

.header {
  margin: 8.82vw 0;
}

.header > h3 {
  font-size: 4.71vw
}

.header > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.main p {
  margin-bottom: 1.47vw;
}

p {
  margin-bottom: 0;
}

.logoDocHead {
  display: flex;
  margin-top: 10px;
  align-items: center
}

.logoDocHead > svg {
  width: 40%;
  padding-right: 40px;
  border-right: 1px black solid
}

.logoDocHead > p {
  width: 60%;
  font-size: 10px;
  padding-left: 20px;
  line-height: normal;
  font-weight: bold
}

@media (min-width: 760px) {
  .header > h3 {
    font-size: 2.11vw;
    text-align: center
  }

  .wrapper {
    font-size: 1.58vw
  }

  .section {
    margin-bottom: 5vw
  }
}

@media (min-width: 1200px) {
  .header {
    margin: 20px 0
  }

  .header > h3 {
    font-size: 16px;
    text-align: center
  }

  .wrapper {
    font-size: 14px;
    width: 800px
  }

  .section {
    margin-bottom: 15px
  }
}

@media only print {
  .header {
    margin-bottom: 20px
  }

  .header > h3 {
    font-size: 16px;
    text-align: center
  }

  .wrapper {
    font-size: 14px;
  }

  .section {
    margin-bottom: 15px
  }

  .logoDocHead > svg {
    width: 40%
  }

}


</style>
